var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg20ErgonomicChairPillow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M639.463 738.321C635.785 728.54 624.504 705.087 622.353 701.004C622.221 700.74 622.043 700.389 621.825 699.961C627.216 697.043 633.267 695.5 639.437 695.5H643.177C647.827 695.5 652.247 697.523 655.287 701.042L669.5 717.5L639.463 738.321Z",
    fill: "url(#paint0_linear_2031_1171)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M642.535 763.747C642.165 766.801 641.718 769.227 641.188 771.3L663 785.5L687.598 768.152C687.806 763.532 687.981 759.34 688.106 756.258L665 772L657 752L642.478 750.126C643.128 754.881 643.064 759.391 642.535 763.747ZM703.535 745.745V756.912L710.5 752V741L703.535 745.745Z",
    fill: "url(#paint1_linear_2031_1171)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M642.485 750.175C642.027 746.798 641.209 743.297 639.942 739.641C639.802 739.235 639.641 738.794 639.463 738.321L669.5 717.5L687.17 719.709C694.062 720.57 700.233 724.135 704.417 729.479C689.285 740.035 664.717 757.244 663.845 758.115C663.167 758.792 662.961 759.604 663.043 760.367L662.605 760.593L663.056 765.436V765.662L663.169 765.887L663.281 766.112L663.394 766.338L663.507 766.563L664.184 766.788L664.296 766.901L664.409 767.013L664.522 767.126L664.634 767.239L664.747 767.351L664.86 767.464L665.086 767.577L665.311 767.689L665.536 767.802L665.762 767.915L665.988 768.027L666.213 768.14L666.439 768.253L666.664 768.365L666.889 768.478L667.115 768.703L667.341 768.928L667.566 769.154L667.792 769.379L668.017 769.492L668.243 769.604L668.468 769.717L668.694 769.83L668.919 769.942L669.145 770.055L669.17 770.067L665 773L662.552 766.573C659.249 757.904 651.59 751.675 642.485 750.175Z",
    fill: "url(#paint2_linear_2031_1171)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M601.773 724.774L588.434 722.996L588.566 722.004L601.905 723.783C607.862 724.577 613.171 727.946 616.427 732.998L625.789 747.525L638.072 748.676C650.106 749.805 660.338 757.932 664.16 769.398L665.259 772.696L709.707 740.595L710.293 741.405L664.741 774.304L663.211 769.715C659.515 758.624 649.618 750.763 637.979 749.672L625.212 748.475L615.587 733.54C612.49 728.734 607.44 725.53 601.773 724.774Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2031_1171",
    x1: 636.245,
    y1: 705.5,
    x2: 662.882,
    y2: 716.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2031_1171",
    x1: 641.472,
    y1: 747.787,
    x2: 712.716,
    y2: 756.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540313,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3E3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2031_1171",
    x1: 657,
    y1: 728.5,
    x2: 690,
    y2: 756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg20ErgonomicChairPillow);
export default __webpack_public_path__ + "static/media/20ErgonomicChairPillow.b2bc015d4226131ef68d7ab01f7a5bf6.svg";
export { ForwardRef as ReactComponent };